import React, { useState, useEffect } from "react";
import { Table, Form, Button, Row, Card, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import backend from "../api/index";
import Modal from "react-bootstrap/Modal";
import Loader from "../components/Loader";
import { requestParticipating } from "../actions/userActions";
import { useHistory } from "react-router";
import { USER_LOGIN_SUCCESS } from "../constants/userConstants";
import QRCode from "react-qr-code";
import download from "downloadjs";
import * as htmlToImage from "html-to-image";

const Profile = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState([]);
  // const [statuses, setStatuses] = useState([]);
  const [modal, setModal] = useState(false);
  const [statusChecked, setStatusChecked] = useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const [balance, setBalance] = useState(0);
  const [loadingBalance, setLoadingBalance] = useState(true);
  const { userInfo } = userLogin;
  console.log("userInfo",userInfo)
  // const { error, loading } = useSelector(
  //   (state) => state.requestParticipatingMerchant
  // );

  const history = useHistory();

  const checkRequestStatus = async () => {
    try {
      const params = {
        merchant_user: userInfo.user?._id,
      };
      const response = await backend.get(`/requestedmerchants`, { params });
      setState(response.data.data[0].Request_status);
      const requestStatus = response?.data?.data?.flatMap((el) =>
        el?.Request_status.map((statusObj) => statusObj?.status)
      );
      if (requestStatus.includes("approved")) {
        const newUser = {
          ...userInfo,
          participating_merchant: true,
        };
        dispatch({ type: USER_LOGIN_SUCCESS, payload: newUser });
      }
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setStatusChecked(true);
    }
  };

  // useEffect(() => {
  //   if (!userInfo) {
  //     history.push(`${process.env.PUBLIC_URL}/`);
  //   } else {
  //     checkRequestStatus();
  //   }
  // }, [userInfo?._id, history, modal]);

  const requestParticipatingMerchant = () => {
    if (userInfo) {
      setModal(true);
      let data = {
        merchant_user: userInfo.user?._id,
        Request_status: [
          {
            status: "pending",
            status_date: new Date(),
          },
        ],
      };
      dispatch(requestParticipating(data));
    }
  };
  const onImageDownload = () => {
    // Event("Download", "QR", "Eksplode code qr");
    htmlToImage
      .toPng(document.getElementById("QR"))
      .then(function(dataUrl) {
        download(dataUrl, "QR.png");
      })
      .catch(function(error) {
        console.error("oops, something went wrong!", error);
      });
  };

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await backend.get("/eMoney-userwallet/earning", {
          params: { ownerId: userInfo.user?._id },
        });

        if (response.data.success) {
          setBalance(response.data.data.balance);
        } else {
          console.error("Failed to fetch balance:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        setLoadingBalance(false);
      }
    };

    if (userInfo?.user?._id) {
      fetchBalance();
    }
  }, [userInfo]);

  return (
    <Card className="">
      <div>
        {userInfo?._id}
      </div>
      <Card.Body>
            {/* {userInfo && ( */}
              <div className="dashboard">
                <div className="page-title">
                <h2>My Dashboard</h2>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <h4>
              <span>Hello,</span>{" "}
              {`${userInfo.user?.firstName} ${userInfo.user?.lastName}`}
            </h4>
            <div>
              {loadingBalance ? (
                <Loader />
              ) : (
                <h5>Balance: ${balance.toFixed(2)}</h5>
              )}
            </div>
          </div>
          <p>
            From your My Account Dashboard you have the ability to view a
            snapshot of your recent account activity and update your account
            information.
          </p>
                <div className="box-account box-info">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="box">
                        <div className="box-title">
                          <h4>Contact Information</h4>
                        </div>
                        <div className="box-content">
                          <h5>
                            Phone &mdash; <span>{userInfo.user?.phone}</span>
                          </h5>
                          <h5>
                            Email &mdash; <span>{userInfo.user?.email}</span>
                          </h5>
                          <h5>
                            Account No &mdash; <span>{userInfo.user?.bankAccount}</span>
                          </h5>
                          <br />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="box">
                        <div className="box-title">
                          <h4>QR Code</h4>
                        </div>
                        <div className="box-content">
                          <div id="QR">
                        <QRCode
                        value={userInfo ? userInfo.user?.bankAccount : null}
                        size={150}
                      ></QRCode>
                      </div>
                      <button
                      className="btn btn-primary mt-3"
                      onClick={() => onImageDownload()}
                    >
                      Download Qr
                    </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {/* )} */}
          </Card.Body>
      {/* {!statusChecked ? (
        <Loader />
      ) : loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Card.Body>
            {userInfo && (
              <div className="dashboard">
                <div className="page-title">
                  <h2>My Dashboard</h2>
                </div>
                <div>
                  <h4>
                    <span>Hello,</span>{" "}
                    {`${userInfo.user?.firstName} ${userInfo.user?.lastName}`}
                  </h4>
                  <p>
                    From your My Account Dashboard you have the ability to view
                    a snapshot of your recent account activity and update your
                    account information.
                  </p>
                </div>
                <div className="box-account box-info">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="box">
                        <div className="box-title">
                          <h4>Contact Information</h4>
                        </div>
                        <div className="box-content">
                          <h5>
                            Phone &mdash; <span>{userInfo.user?.phone}</span>
                          </h5>
                          <h5>
                            Email &mdash; <span>{userInfo.user?.email}</span>
                          </h5>
                          <br />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="box">
                        <div className="box-title">
                          <h4>eksplode! Code</h4>
                        </div>
                        <div className="box-content">
                          <h5>
                            <span>{userInfo.user?.eksplode_code}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Card.Body>
          <br />
          {userInfo && userInfo.participating_merchant === false && (
            <Row>
              <Col md={12}>
                <Card className="text-center">
                  <Card.Body>
                    <Card.Title>Become a Participating Retailer.</Card.Title>
                    <Card.Text>
                      A Chance to sell products and much more.
                    </Card.Text>
                    <Button
                      variant="danger"
                      onClick={requestParticipatingMerchant}
                      disabled={
                        state.at(-1) && state.at(-1).status === "pending"
                      }
                    >
                      Submit request
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
          {userInfo && userInfo.participating_merchant === true && (
            <Row>
              <Col md={12}>
                <Card className="text-center">
                  <Card.Body>
                    <Card.Title>You’re a Participating Merchant!</Card.Title>
                    <Card.Text>
                      Congratulations! You are now a participating retailer and
                      can start selling products.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </>
      )}
      <Modal
        size="lg"
        show={modal}
        onClose={() => {
          setModal(false);
        }}
      >
        <div className="container px-5 pt-5 py-5 custom-modal">
          <div className="row">
            <h3 className="text-muted text-center my-5">
              Your request to become a participating retailer has been received.
              You will be informed through e-mail if your request has been
              approved.
            </h3>
          </div>
          <div className="row mt-3 justify-content-center">
            <button
              className="btn btn-danger"
              style={{ minWidth: "200px" }}
              onClick={() => setModal(false)}
            >
              Okay
            </button>
          </div>
        </div>
      </Modal> */}
    </Card>
  );
};

export default Profile;
